import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Row, Col, Label, Button } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PersonIncomeModal from "../../../../Modal/PersonIncome/PersonIncomeModal";
import { PersonType } from "../../types";

import { FormField, SelectFormField, CustomFormInput, CheckFormField } from "../../../../../utils/FormFields";
import JuridicalPersonLegalAddress from "../LegalAddress";
import JuridicalPersonFiscalResidence from "../FiscalResidence";
import Autosuggest from "../../../../AutosuggestCompliance";
import CircularProggress from "../../../../CircularProgress/CircularProgress";
import { toDateTime } from "../../../../../utils/dateUtils";
import { PersonMode, showToast } from "../../../../../utils/Helper";
import { CurrencyType, RelatedFrom, shareType, PersonStatus } from "../../types";
import CustomDropdown from "../../../../CustomDropdown/CustomDropdown";

function JuridicalPersonProfile({
  person,
  onChange,
  legalAddress,
  onChangeAddress,
  autosuggests,
  onChangeAutosuggest,
  documentTypes,
  entityTypes,
  activitySectors,
  societyTypes,
  publicPositions,
  disabled,
  errors,
  companyLinks,
  professions,
  services,
  role,
  holder,
  onboarding,
  mode,
  manual,
  needsExtraFields,
  currencies,
  refresh,
}) {

  const [secondaryActivity, setSecondaryActivity] = useState(false);
  const [newTLFormulaEnabled, setNewTLFormulaEnabled] = useState(false);
  const [incomeModalOpen, setIncomeModalOpen] = useState(false);
  const [incomes, setIncomes] = useState(null);
  const [incomesLoading, setIncomesLoading] = useState(false);
  // Meses de antigüedad válidos para las fechas del modal de ingresos (parametrizable).
  const [docExpirationMonths, setDocExpirationMonths] = useState(24);

  useEffect(() => {
    if (services && services.getParameterValue) {
      services.getParameterValue({ ParameterName: "DOC_EXPIRATION_MONTHS" }, (r) => {
        const v = r && r.SdtParametersData && Number(r.SdtParametersData.ParameterNumericValue);
        if (v && !Number.isNaN(v)) setDocExpirationMonths(v);
      });
    }
  }, []);

  // Al abrir "Load incomes" traemos los incomes ya cargados para prellenar
  // las sub-tabs de la modal; recién ahí la abrimos (con spinner mientras carga).
  const openIncomeModal = () => {
    if (services && services.fetchPersonIncomesData && person && person.PersonId) {
      setIncomesLoading(true);
      services.fetchPersonIncomesData({ PersonId: person.PersonId }, (data) => {
        setIncomesLoading(false);
        setIncomes(data || []);
        setIncomeModalOpen(true);
      });
    } else {
      setIncomes([]);
      setIncomeModalOpen(true);
    }
  };

  // Al confirmar, persistimos la colección completa (existentes + nuevas) con
  // SetPersonIncomesData. Si el result es 200: cerramos la modal y refrescamos
  // la persona (para ver los totales recalculados). El modal muestra el error si falla.
  const handleIncomeSubmit = (payload, done) => {
    if (services && services.setPersonIncomesData && person && person.PersonId) {
      services.setPersonIncomesData(
        { PersonId: person.PersonId, SDTPersonIncomesCollection: payload.SDTPersonIncomesCollection },
        (data, err) => {
          const result = data && data.result;
          const ok = !err && result && Number(result.Code) === 200;
          if (ok) {
            showToast("Income data saved successfully");
            setIncomeModalOpen(false);
            if (refresh) refresh();
          } else {
            showToast((result && result.Description) || (err ? String(err) : "Error saving income data"), true);
          }
          if (done) done(ok);
        }
      );
    } else {
      setIncomeModalOpen(false);
      if (done) done(true);
    }
  };
  const fetchSectorSuggestion = (name) =>
    new Promise((resolve, reject) => {
      services.fetchAutosuggestSector({ text: name }, (response) => {
        if (response && response.sectors) {
          const suggestions = response.sectors.map((c) => ({
            id: c.Id,
            name: c.Description,
          }));
          resolve(suggestions);
        } else {
          reject();
        }
      });
    });
  
  const fetchCountrySuggestion = (name) =>
    new Promise((resolve, reject) => {
      services.fetchAutosuggestCoutries({ text: name }, (response) => {
        if (response && response.countries) {
          const suggestions = [];
          response.countries.map((c) => {
            suggestions.push({
              id: c.Id,
              name: c.Name,
            });
            return {};
          });
          resolve(suggestions);
        } else {
          reject();
        }
      });
    });
  
  useEffect(()=>{
      services.getParameterValue(( { ParameterName: 'SecondaryActivitySectorOn' } ),(r) => {
  
        if (r.SdtParametersData.ParameterNumericValue == 0) {
          setSecondaryActivity(false)
        } else {
          setSecondaryActivity(true)
        }

    })},[])

  useEffect(() => {
    services.getParameterValue({ ParameterName: "NewTLFormula" }, (r) => {
      if (r && r.SdtParametersData) {
        setNewTLFormulaEnabled(r.SdtParametersData.ParameterNumericValue == 1);
      }
    });
  }, []);
  
  
  const onChangeSector = (value) => onChangeAutosuggest("PersonActivitySector", value);
  const onChangeConstPlace = (value) => onChangeAutosuggest("JuridicalPersonConstPlace", value);
  const handleSelectSector = (id, value) => {
    onChange("PersonActivitySectorId", id, value);
    onChangeSector(value);
  };
  const handleSelectConstPlace = (id, value) => {
    onChange("JuridicalPersonConstPlaceId", id, value);
    onChangeConstPlace(value);
  };

  const [error, setError] = useState(onboarding ? "Check Document First" : "");
  const [color, setColor] = useState("btn btn-ladda btn-primary");
  const [checking, setChecking] = useState(false);

  const isPEP = parseInt(person.JuridicalPersonPublicPosition, 10) > 1;

  const checkDocument = () => {
    if (person.JuridicalPersonTAXId == "") {
      setColor("btn btn-ladda btn-primary");
      setError("Please, add a document number");
    } else {
      setChecking(true);
      services.fetchCheckDocument(
        {
          onboardingid: person.PersonId,
          type: person.JuridicalPersonDocumentTypeId,
          number: person.JuridicalPersonTAXId,
          person: "Juridical",
        },
        (response) => {
          if (response && response.result.Code === 200) {
            setColor("btn btn-ladda btn-primary");
            setError(undefined);
            setChecking(false);
            alert(response.result.Description);
          } else {
            setError("This document already exists!");
            setColor("btn btn-ladda btn-danger btn-sm");
            setChecking(false);
            alert(response.result.Description);
          }
        }
      );
    }
  };


  const onChangeDoc = (id, value, text) => {
    onChange(id, value, text);
      setError("Check Document First");

}

  const onChangeDocNumber = (id, value) => {
    onChange(id, value);
    setError("Check Document First");
}

const configuredDecimalSeparator =
typeof window !== "undefined" &&
window.___APP_CONFIG___ &&
window.___APP_CONFIG___.DECIMAL_SEPARATOR;

const decimalSeparator = configuredDecimalSeparator === "." ? "." : ",";
const thousandSeparator = decimalSeparator === "." ? "," : ".";

  // Neutral panel used to highlight the financial fields row when the new TL
  // formula is on. Same style used elsewhere in the system (e.g. KYC tab).
  const highlightStyle = {
    border: "1px solid #d6d6d6",
    borderRadius: "8px",
    backgroundColor: "#f8f9fa",
    padding: "16px",
    marginBottom: "16px",
  };

  return (
    <div>
      {(
        <Row>
          <Col>
            { documentTypes && (
              <SelectFormField
                label="Type"
                name="JuridicalPersonDocumentTypeId"
                onChange={onChangeDoc}
                disabled={disabled}
                error={errors.JuridicalPersonDocumentTypeId}
                value={person.JuridicalPersonDocumentTypeId}
                selectItems={documentTypes}
                getSelectItemId={(i) => i.DocumentTypeId}
                getSelectItemName={(i) => i.DocumentTypeName}
              />
            )}
          </Col>
          <Col>
            <FormField
              label="TAX"
              name="JuridicalPersonTAXId"
              onChange={onChangeDocNumber}
              error={errors.JuridicalPersonTAXId || error}
              value={person.JuridicalPersonTAXId}
            />
          </Col>
          <Col>
              <Label>Check if the person already exist</Label>
              <div></div>
              <LaddaButton
                className={color}
                loading={checking}
                onClick={checkDocument}
                data-style={EXPAND_RIGHT}
                color={color}
              >
                <i className="fa fa-check-square" aria-hidden="true"></i>
              </LaddaButton>
          </Col>
        </Row>
      )}
      <FormField
        label="Legal Name: "
        value={person.JuridicalPersonLegalName}
        name="JuridicalPersonLegalName"
        onChange={onChange}
        disabled={disabled || error || !manual}
        error={errors.JuridicalPersonLegalName}
      />
      <FormField label="Type: " value={person.PersonType} name="PersonType" disabled />
      <SelectFormField
        label="Status: "
        value={person.PersonStatus}
        name="PersonStatus"
        selectItems={Object.keys(PersonStatus)}
        getSelectItemId={(i) => i}
        getSelectItemName={(i) => PersonStatus[i]}
        error={errors.PersonStatus}
        onChange={onChange}
        disabled={disabled || error || onboarding || mode === PersonMode.New}
      />
      {person.PersonActivationDate && mode !== PersonMode.New && (
        <FormField
          label="Activation Date: "
          type="date"
          value={toDateTime(person.PersonActivationDate)}
          name="PersonActivationDate"
          onChange={onChange}
          disabled={true}
          error={errors.PersonActivationDate}
        />
      )}
      <CheckFormField
        label="Obligated Entity? : "
        error={errors.PersonObligatedEntity}
        onChange={onChange}
        value={person.PersonObligatedEntity}
        initialValue={person.PersonObligatedEntity}
        name="PersonObligatedEntity"
        disabled={disabled || error || !manual}
      />
      <Row>
        <Col>
          {entityTypes ? (
            <SelectFormField
              label="Entity Type"
              name="JuridicalPersonEntityTypeId"
              onChange={onChange}
              disabled={role == "advisor" ? true : disabled || error || !manual}
              error={errors.JuridicalPersonEntityTypeId}
              value={person.JuridicalPersonEntityTypeId}
              selectItems={entityTypes}
              getSelectItemId={(i) => i.EntityTypeId}
              getSelectItemName={(i) => i.EntityTypeDescription}
            />
          ) : (
            <CircularProggress sm />
          )}
        </Col>

        <Col>
          {societyTypes ? (
            <SelectFormField
              label="Society Type"
              name="JuridicalPersonSocietyTypeId"
              onChange={onChange}
              disabled={role == "advisor" ? true : disabled || error || !manual}
              error={errors.JuridicalPersonSocietyTypeId}
              value={person.JuridicalPersonSocietyTypeId}
              selectItems={societyTypes}
              getSelectItemId={(i) => i.SocietyTypeId}
              getSelectItemName={(i) => i.SocietyTypeDescription}
            />
          ) : (
            <CircularProggress sm />
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <FormField
            label="Constitution Date"
            value={toDateTime(person.JuridicalPersonConstDate)}
            type="date"
            name="JuridicalPersonConstDate"
            onChange={onChange}
            disabled={disabled || error}
            error={errors.JuridicalPersonConstDate}
          />
        </Col>
        <Col>
          <CustomFormInput label="Constitution Place: " error={errors.JuridicalPersonConstPlaceId}>
            <Autosuggest
              value={autosuggests.JuridicalPersonConstPlace}
              onChange={onChangeConstPlace}
              fecthSuggestions={fetchCountrySuggestion}
              onSelect={handleSelectConstPlace}
              disabled={disabled || error}
            />
          </CustomFormInput>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormField
            label="Email: "
            type="email"
            value={person.PersonEmail}
            name="PersonEmail"
            onChange={onChange}
            disabled={disabled || error}
            error={errors.PersonEmail && !person.PersonIsMinimal ? errors.PersonEmail : undefined}
          />
        </Col>
        <Col>
          <FormField
            label="Issue Place"
            value={person.JuridicalPersonIssuePlace}
            name="JuridicalPersonIssuePlace"
            onChange={onChange}
            disabled={disabled || error}
            error={errors.JuridicalPersonIssuePlace}
          />
        </Col>
      </Row>

      {shareType ? (
        <SelectFormField
          label="Share Type: "
          value={person.JuridicalPersonShareType}
          name="JuridicalPersonShareType"
          onChange={onChange}
          selectItems={shareType}
          getSelectItemId={(i) => i.id}
          getSelectItemName={(i) => i.name}
          error={errors.JuridicalPersonShareType}
          disabled={disabled || error}
        />
      ) : (
        <CircularProggress sm />
      )}
      <Row>
        {person.PersonType != PersonType.Juridical && (
          <Col>
            <SelectFormField
              label="Profession: "
              value={person.PersonProfessionId}
              name="PersonProfessionId"
              onChange={onChange}
              selectItems={
                professions || [
                  {
                    ProfessionId: person.PersonProfessionId,
                    ProfessionName: person.PersonProfessionName,
                  },
                ]
              }
              getSelectItemId={(profession) => profession.ProfessionId}
              getSelectItemName={(profession) => profession.ProfessionName}
              disabled={disabled || error || !manual}
              error={errors.PersonProfessionId}
            />
          </Col>
        )}
        <Col>
          <CustomDropdown
            value={person.PersonActivitySectorId}
            label="Activity Sector: "
            name="PersonActivitySectorId"
            onChange={onChange}
            items={activitySectors}
            getSelectedId={(activitySector) => activitySector.Id}
            getSelectedName={(activitySector) => `${activitySector.Code} - ${activitySector.Description}`}
            getFilterCondition={(activitySector) => activitySector.Description + " " + activitySector.Code}
            disabled={disabled || !manual || error}
            error={errors.PersonActivitySectorId}
            extendInfo={true}
          />
        </Col>
        { secondaryActivity && 
        <Col>
        <CustomDropdown
            value={person.PersonSecondActivitySectorId}
            label="Secondary Activity Sector: "
            name="PersonSecondActivitySectorId"
            onChange={onChange}
            items={activitySectors}
            getSelectedId={(activitySector) => activitySector.Id}
            getSelectedName={(activitySector) => `${activitySector.Code} - ${activitySector.Description}`}
            getFilterCondition={(activitySector) => activitySector.Description + " " + activitySector.Code}
            disabled={disabled || !manual || error}
            extendInfo={true}
          />
        </Col>}
        <Col>
          <SelectFormField
            label="Public Position: "
            value={person.JuridicalPersonPublicPosition}
            name="JuridicalPersonPublicPosition"
            onChange={onChange}
            selectItems={
              publicPositions || [
                {
                  PublicPositionId: person.JuridicalPersonPublicPosition,
                  PublicPositionName: person.JuridicalPersonPublicPosition,
                },
              ]
            }
            getSelectItemId={(publicPosition) => publicPosition.PublicPositionId}
            getSelectItemName={(publicPosition) => publicPosition.PublicPositionName}
            disabled={disabled || !manual}
            description={isPEP ? "PEP" : undefined}
            error = {errors.JuridicalPersonPublicPosition}
          />
        </Col>
      </Row>
      <div style={newTLFormulaEnabled ? highlightStyle : undefined}>
        <Row>
          <Col>
            <FormField
              label="Person Transactional Limit: "
              disabled={disabled || role !== 'Compliance' || !person.manualTransactionalLimit}
              onChange={onChange}
              value={person.PersonTransactionalLimit}
              name="PersonTransactionalLimit"
              type="number"
              dataTypeDecimalName="currency"
              thousandSeparator={thousandSeparator}
            />
          </Col>
          {newTLFormulaEnabled && (
            <Col>
              <FormField
                label="Estimated Net Worth: "
                disabled={true}
                onChange={onChange}
                value={person.PersonEstimatedNetworth}
                name="PersonEstimatedNetworth"
                type="number"
                dataTypeDecimalName="currency"
                thousandSeparator={thousandSeparator}
              />
            </Col>
          )}
          <Col>
            <FormField
              label="Anual Income: "
              disabled={disabled || error || newTLFormulaEnabled}
              onChange={onChange}
              value={person.PersonAnualIncome}
              name="PersonAnualIncome"
              error={errors.PersonAnualIncome}
              type="number"
              dataTypeDecimalName="currency"
              thousandSeparator={thousandSeparator}
            />
          </Col>
          <Col>
            <FormField
              label="Anual Extra Income: "
              disabled={disabled || error || newTLFormulaEnabled}
              onChange={onChange}
              value={person.PersonExtraIncomeVolume}
              name="PersonExtraIncomeVolume"
              error={errors.PersonExtraIncomeVolume}
              type="number"
              dataTypeDecimalName="currency"
              thousandSeparator={thousandSeparator}
            />
          </Col>
        </Row>
        {newTLFormulaEnabled && services && services.fetchPersonIncomesData && (
          <Button color="link" className="p-0" onClick={openIncomeModal} disabled={incomesLoading} title="Load incomes">
            <i className={`fa ${incomesLoading ? "fa-spinner fa-spin" : "fa-plus-circle"}`} /> Load incomes
          </Button>
        )}
      </div>

      <PersonIncomeModal
        isOpen={incomeModalOpen}
        toggle={() => setIncomeModalOpen(false)}
        personType="Juridical"
        minMonths={docExpirationMonths}
        currencies={currencies}
        onSubmit={handleIncomeSubmit}
        initialData={incomes}
        onRecalculate={
          services && services.recalculatePersonIncomes
            ? (payload, cb) =>
                services.recalculatePersonIncomes(
                  { PersonId: person.PersonId, ...payload },
                  (data) => cb(data)
                )
            : undefined
        }
      />

      <Row>
        <Col>
          <SelectFormField
            label="Currency Type: "
            value={person.PersonCurrencyType}
            name="PersonCurrencyType"
            selectItems={Object.keys(CurrencyType)}
            getSelectItemId={(i) => i}
            getSelectItemName={(i) => CurrencyType[i]}
            error={errors.CurrencyType}
            onChange={onChange}
            disabled={disabled || error}
          />
        </Col>
        <Col>
          <SelectFormField
            label="Related From: "
            value={person.PersonRelatedFrom}
            name="PersonRelatedFrom"
            selectItems={Object.keys(RelatedFrom)}
            getSelectItemId={(i) => i}
            getSelectItemName={(i) => RelatedFrom[i]}
            error={errors.RelatedFrom}
            onChange={onChange}
            disabled={disabled || error}
          />
        </Col>
        <Col>
          <FormField
            label="Observations: "
            name="PersonObservations"
            //error={errors.PersonObservations}
            onChange={onChange}
            disabled={disabled}
            value={person.PersonObservations}
          />
        </Col>
      </Row>

      {/* <JuridicalPersonLegalAddress
        legalAddress={legalAddress}
        onChangeAddress={onChangeAddress}
        autosuggests={autosuggests}
        onChangeAutosuggest={onChangeAutosuggest}
        disabled={disabled || error}
        errors={errors}
        services={services}
      /> */}
    </div>
  );
}

JuridicalPersonProfile.propTypes = {
  person: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeAddress: PropTypes.func.isRequired,
  autosuggests: PropTypes.object.isRequired,
  onChangeAutosuggest: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  companyLinks: PropTypes.array,
  professions: PropTypes.array,
  documentTypes: PropTypes.array,
  entityTypes: PropTypes.array,
  societyTypes: PropTypes.array,
  services: PropTypes.object.isRequired,
};

JuridicalPersonProfile.defaultProps = {
  companyLinks: undefined,
  professions: undefined,
  documentTypes: undefined,
  entityTypes: undefined,
  societyTypes: undefined,
};

export default JuridicalPersonProfile;
